import { useMemo } from "react";
import { useCartStore, type CartStoreItem } from "@/stores/cartStore";

export interface CartItem {
  id: string;
  title: string;
  description: string;
  tag: string;
  price: number;
}

export const useCart = () => {
  const items = useCartStore((state) => state.items);
  const addStoreItem = useCartStore((state) => state.addItem);
  const removeStoreItem = useCartStore((state) => state.removeItem);
  const clearCart = useCartStore((state) => state.clearCart);
  const checkoutUrl = useCartStore((state) => state.checkoutUrl);
  const isLoading = useCartStore((state) => state.isLoading);
  const isSyncing = useCartStore((state) => state.isSyncing);

  const total = useMemo(
    () => items.reduce((sum, item) => sum + Number(item.price.amount) * item.quantity, 0),
    [items],
  );

  const count = useMemo(() => items.reduce((sum, item) => sum + item.quantity, 0), [items]);

  const isInCart = (id: string) => items.some((item) => item.productId === id);

  const addItem = async (item: Omit<CartStoreItem, "lineId" | "quantity"> & { quantity?: number }) => {
    await addStoreItem(item);
  };

  const removeItem = async (id: string) => {
    await removeStoreItem(id);
  };

  return {
    items,
    total,
    addItem,
    removeItem,
    clearCart,
    isInCart,
    count,
    checkoutUrl,
    isLoading,
    isSyncing,
  };
};
